import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

export interface AuthState {
  isLoggedIn: boolean;
  email: string;
  role: string;
  firstName: string;
  lastName: string;
}

const initialState: AuthState = {
  isLoggedIn: false,
  email: "",
  role: "",
  firstName: "",
  lastName: "",
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    logout: () => {
      return initialState;
    },
    setAuthDetails: (state, { payload }) => {
      state.isLoggedIn = payload.isLoggedIn;
      state.role = payload.role;
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.email = payload.email;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { logout, setAuthDetails } = authSlice.actions;

export default authSlice.reducer;
